export const STATUS_CATEGORY_NEW = 'STATUS_CATEGORY_NEW';
export const STATUS_CATEGORY_IN_PROGRESS = 'STATUS_CATEGORY_IN_PROGRESS';
export const STATUS_CATEGORY_FINISHED = 'STATUS_CATEGORY_FINISHED';
export const STATUS_CATEGORY_CANCELLED = 'STATUS_CATEGORY_CANCELLED';
